import './styles.css';
import { ToastProvider, TooltipProvider } from '@agentic/ui-kit';
import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { LiveAnnouncer } from './app/live.tsx';
import { createQueryClient, keys } from './app/queries.ts';
import { RouteError, RoutePending } from './app/route-states.tsx';
import { ToastBridge } from './app/toast-bridge.tsx';
import { routeTree } from './routeTree.gen.ts';

const queryClient = createQueryClient({
  onUnauthorized: () => {
    queryClient.removeQueries({ queryKey: keys.me });
    if (router.state.location.pathname !== '/login') {
      void router.navigate({ to: '/login', search: { redirect: router.state.location.href } });
    }
  },
});

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultPendingComponent: RoutePending,
  defaultErrorComponent: RouteError,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <TooltipProvider delayDuration={300}>
            <LiveAnnouncer>
              <ToastBridge />
              <RouterProvider router={router} />
            </LiveAnnouncer>
          </TooltipProvider>
        </ToastProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}
